import { HttpResponse } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FileDownloadService } from '@services/file-download.service';
import { FilenameParser } from '@utils/FilenameParser';
import moment from 'moment';
import { take } from 'rxjs/operators';
import { HistoricoImportacoesService } from 'src/app/services/historico-importacoes.service';
import {UploadFileService} from '@services/upload-file.service';
import {ToastrService} from 'ngx-toastr';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { MatSuffix } from '@angular/material/form-field';
import { FieldErrorComponent } from '../../components/field-error/field-error.component';
import { SelectComponent } from '../../components/select/select.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';

@Component({
    selector: 'app-historico-importacoes',
    templateUrl: './historico-importacoes.component.html',
    styleUrls: ['./historico-importacoes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, BreadcrumbComponent, DateMaskDirective, MatDatepickerInput, FormsModule, NgClass, MatDatepickerToggle, MatSuffix, MatDatepicker, FieldErrorComponent, SelectComponent, FooterComponent, CamelCasePipe]
})
export class HistoricoImportacoesComponent implements OnInit {

  idEmpresaLogada: string;
  historicoImportacao: any = null;
  dataInicial: any = '';
  dataFinal: any = '';
  dataFinalMessageError: any;
  dataFinalVazia: any;
  dataFinalError: any;
  dataInicialError: any;
  dataInicialMessageError: any;
  dataInicialVazia: any;
  pagina: any = 0;
  tamanho: any = 5;
  itensPaginacao: Array<any> = [];
  dataFinalLength = false;
  dataInicialLength = false;

  constructor(private readonly service: HistoricoImportacoesService,
              private readonly Toastr: ToastrService,
              private readonly uploadFileService: UploadFileService) {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
  }

  ngOnInit(): void {
    window.scroll(0, 0);
    this.consultaHistoricoImportacoes();
  }

  // CONSULTA HISTÓRICO DE IMPORTAÇÕES (TABELA NO FINAL DA TELA)
  consultaHistoricoImportacoes() {
    this.historicoImportacao = null;

    if (this.idEmpresaLogada) {
      this.service.getImportacoes(this.idEmpresaLogada, this.pagina, this.tamanho, this.dataInicial, this.dataFinal)
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {
            this.historicoImportacao = response.response;
            this.configuracaoPaginacao();
          },
          error: (erro: any) => {
            console.error(erro);
            if (erro.error.mensagem === 'Sem historico de importacao') {
              this.historicoImportacao = undefined;
            } else {
              this.historicoImportacao = false;
            }
          }
        });

        } else { this.historicoImportacao = false; }
  }

  limparFiltro(){
    this.dataFinal = '';
    this.dataInicial = '';
    this.dataFinalError = false;
    this.dataInicialError = false;
    this.dataInicialLength = false;
    this.dataFinalLength = false;
    this.consultaHistoricoImportacoes();

  }

  downloadImportacao(importacao){
    this.service.downloadImportacao(this.idEmpresaLogada, importacao.idImportacao).pipe(take(1))
    .subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        const filename = FilenameParser.fromContentDispositionHeader(
            headers.get('content-disposition'));
        FileDownloadService.download([body] , filename);
      }, error: (error) => {
        console.error(error)
      }
    });
  }

  goBackPage() { window.history.back(); }

  configuracaoPaginacao() {
    this.itensPaginacao = [];

    if (this.historicoImportacao.totalPages <= 7) {
      for (let i = 0; i < this.historicoImportacao.totalPages; i++) {
        const objPagina = {
          valor: i,
          pagina: i + 1
        };
        this.itensPaginacao.push(objPagina);
      }
    } else if ([1, 2, 3, 4].includes(this.pagina)) {

        this.itensPaginacao = [
          {
            valor: 0,
            pagina: 1
          },
          {
            valor: 1,
            pagina: 2
          },
          {
            valor: 2,
            pagina: 3
          },
          {
            valor: 3,
            pagina: 4
          },
          {
            valor: 4,
            pagina: 5
          },
          {
            valor: '...',
            pagina: '...'
          },
          {
            valor: this.historicoImportacao.totalPages - 1,
            pagina: this.historicoImportacao.totalPages
          }
        ];

      } else if (this.pagina === this.historicoImportacao.totalPages ||
        this.pagina === this.historicoImportacao.totalPages - 1 ||
        this.pagina === this.historicoImportacao.totalPages - 2
        || this.pagina === this.historicoImportacao.totalPages - 3 ) {

        this.itensPaginacao = [
          {
            valor: 0,
            pagina: 1
          },
          {
            valor: '...',
            pagina: '...'
          },
          {
            valor: this.historicoImportacao.totalPages - 5,
            pagina: this.historicoImportacao.totalPages - 4
          },
          {
            valor: this.historicoImportacao.totalPages - 4,
            pagina: this.historicoImportacao.totalPages - 3
          },
          {
            valor: this.historicoImportacao.totalPages - 3,
            pagina: this.historicoImportacao.totalPages - 2
          },
          {
            valor: this.historicoImportacao.totalPages - 2,
            pagina: this.historicoImportacao.totalPages - 1
          },
          {
            valor: this.historicoImportacao.totalPages - 1,
            pagina: this.historicoImportacao.totalPages
          }
        ];

      } else {
        this.itensPaginacao = [
          {
            valor: 0,
            pagina: 1
          },
          {
            valor: '...',
            pagina: '...'
          },
          {
            valor: this.pagina - 1,
            pagina: this.pagina
          },
          {
            valor: this.pagina,
            pagina: this.pagina + 1
          },
          {
            valor: this.pagina + 1,
            pagina: this.pagina + 2
          },
          {
            valor: '...',
            pagina: '...'
          },
          {
            valor: this.historicoImportacao.totalPages - 1,
            pagina: this.historicoImportacao.totalPages
          }
        ];
      }
  }

  alteraQuantidadePorPagina() {
    this.pagina = 0;
    this.consultaHistoricoImportacoes();
  }

  alteraPagina(numeroPagina: any) {

    if (this.pagina !== numeroPagina && numeroPagina !== '...'){
      this.pagina = numeroPagina;
      this.consultaHistoricoImportacoes();
    }

  }

  onDataInicialPedido() {

    if (this.dataFinal) {
      if (moment(this.dataInicial) > moment(this.dataFinal)) {

        this.dataInicialError = true;
        this.dataInicialMessageError = 'Data Inicial maior que a data Final';
      } else {
        this.dataInicialError = false;
      }
    } else {
      this.dataInicialError = false;
    }

    if (this.dataInicial){
      this.dataInicialLength = this.dataInicial.toISOString().substring(0, 10).length == 10;
    }
  }


  checkLimite90Dias() {
    const dataInicio = moment(this.dataInicial);
    const dataFinal = moment(this.dataFinal);

    if (this.dataInicial && this.dataFinal){
      if (dataFinal.isAfter(dataInicio.add(90, 'days'))) {
        this.dataFinalError = true;
        this.dataFinalMessageError = 'Favor pesquisar período menor que 90 dias.';
      }else if ((moment(this.dataInicial) <= moment(this.dataFinal))){
        this.dataFinalError = false;
      }
    }

  }

  onDataFinalPedido() {

    if (this.dataInicial) {
      if (moment(this.dataInicial) > moment(this.dataFinal)) {
        this.dataFinalError = true;
        this.dataFinalMessageError = 'Data Final menor que a data Inicial';
      }
      else {
        this.dataFinalError = false;
      }
    } else {
      this.dataFinalError = false;
    }

    if (this.dataFinal) {
      this.dataFinalLength = this.dataFinal.toISOString().substring(0, 10).length == 10;
    }
  }

  downloadErrosImportacao(idImportacao: string) {
    this.uploadFileService.getDownloadInconsistencias(idImportacao)
      .pipe(take(1))
      .subscribe({
        next: ({body, headers}: HttpResponse<any>) => {
          const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'),
          'Arquivo.csv',
        );
        FileDownloadService.download([body] , filename);
        }, error: (error) => {
          this.Toastr.error(
            error.error.mensagem, '', {
            timeOut: 2000,
          });
        }
      });
  }


  dsadsadasdas(idImportacao: string){
  this.uploadFileService.getDownloadInconsistencias(localStorage.getItem('idImportacao')).pipe(take(1))
  .subscribe({
    next: ({body, headers}: HttpResponse<any>) => {
      const filename = FilenameParser.fromContentDispositionHeader(
        headers.get('content-disposition'),
        'Arquivo.csv',
      );
      FileDownloadService.download([body] , filename);
    }, error: (error) => {
      this.Toastr.error(error.error.mensagem, '', {
        timeOut: 2000,
      });
    }
  });
  }
}
